export default __webpack_public_path__ + "static/rauchmehl-7e8403cb128dd2dd9c402ec164e10a7a.png";